var _ellipse, _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserstwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 17,
    rx: 6,
    ry: 2.5,
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.5,
    r: 3,
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44547 13.7617C5.20689 13.8133 4.06913 14.0364 3.18592 14.3897C2.68122 14.5915 2.22245 14.8507 1.87759 15.1768C1.53115 15.5045 1.25 15.9514 1.25 16.5002C1.25 17.0491 1.53115 17.496 1.87759 17.8236C2.22245 18.1498 2.68122 18.4089 3.18592 18.6108C3.68571 18.8107 4.26701 18.969 4.90197 19.078C4.40834 18.5455 4.09852 17.9506 4.01985 17.3197C3.92341 17.2872 3.83104 17.2533 3.74301 17.2181C3.34289 17.058 3.06943 16.8862 2.90826 16.7338C2.7498 16.584 2.74999 16.5048 2.75 16.5003L2.75 16.5002L2.75 16.5002C2.74999 16.4956 2.7498 16.4165 2.90826 16.2667C3.06943 16.1142 3.34289 15.9424 3.74301 15.7824C3.94597 15.7012 4.17201 15.6268 4.41787 15.5611C4.83157 14.8712 5.53447 14.2562 6.44547 13.7617Z",
    fill: "#28303F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9802 17.3197C19.9015 17.9506 19.5917 18.5455 19.0981 19.078C19.733 18.969 20.3143 18.8107 20.8141 18.6108C21.3188 18.4089 21.7776 18.1498 22.1224 17.8236C22.4689 17.496 22.75 17.0491 22.75 16.5002C22.75 15.9514 22.4689 15.5045 22.1224 15.1768C21.7776 14.8507 21.3188 14.5916 20.8141 14.3897C19.9309 14.0364 18.7931 13.8133 17.5546 13.7617C18.4656 14.2562 19.1685 14.8712 19.5822 15.5611C19.828 15.6268 20.0541 15.7012 20.257 15.7824C20.6571 15.9424 20.9306 16.1142 21.0918 16.2667C21.2502 16.4165 21.25 16.4956 21.25 16.5002V16.5002V16.5003C21.25 16.5048 21.2502 16.584 21.0918 16.7338C20.9306 16.8862 20.6571 17.058 20.257 17.2181C20.169 17.2533 20.0766 17.2872 19.9802 17.3197Z",
    fill: "#28303F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5144 10.6522C16.2945 11.1126 16.0063 11.5341 15.6628 11.9036C16.0586 12.1243 16.5146 12.25 17 12.25C18.5188 12.25 19.75 11.0188 19.75 9.5C19.75 7.98122 18.5188 6.75 17 6.75C16.8957 6.75 16.7928 6.7558 16.6915 6.76711C16.8636 7.23272 16.9683 7.73096 16.9939 8.25001C16.9959 8.25 16.9979 8.25 17 8.25C17.6904 8.25 18.25 8.80964 18.25 9.5C18.25 10.1904 17.6904 10.75 17 10.75C16.8278 10.75 16.6637 10.7152 16.5144 10.6522Z",
    fill: "#28303F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30845 6.76711C7.20719 6.7558 7.10427 6.75 7 6.75C5.48122 6.75 4.25 7.98122 4.25 9.5C4.25 11.0188 5.48122 12.25 7 12.25C7.48537 12.25 7.94138 12.1243 8.33721 11.9036C7.99374 11.5341 7.70549 11.1126 7.4856 10.6522C7.33631 10.7152 7.17222 10.75 7 10.75C6.30964 10.75 5.75 10.1904 5.75 9.5C5.75 8.80964 6.30964 8.25 7 8.25C7.00205 8.25 7.00409 8.25 7.00614 8.25001C7.0317 7.73096 7.13641 7.23272 7.30845 6.76711Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserstwo);
export default __webpack_public_path__ + "static/media/userstwo.1afc26cf.svg";
export { ForwardRef as ReactComponent };